<!-- 设备列表页面 -->
<template>
  <div class="vcnDeviceList vcnDevicelist_warpd">
    <!--主页面 -->
    <div class="flex-row"
         style="height: 100%">
      <!-- 左侧树 -->
      <div class="section-mian_left">
        <el-scrollbar style="height: 100%">
          <el-tree :data="frame"
                   :props="treeProps"
                   class="tree-content"
                   @node-click="currentChange"
                   :expand-on-click-node="true"
                   :default-expand-all="false"
                   :default-expanded-keys="['1']"
                   :highlight-current="true"
                   node-key="areaCode"
                   ref="vuetree">
            <div class="custom-tree-node"
                 slot-scope="{ node, data }">
              <div class="tree-label"
                   :title="node.label">{{ node.label }}</div>
              <div class="area-operator"
                   @click="addClick">
                <el-button type="text"
                           class="el-icon-edit-outline"
                           size="mini"
                           v-if="areaCode == data.areaCode"
                           @click="() => editArea(node, data)"></el-button>
              </div>
            </div>
          </el-tree>
        </el-scrollbar>
      </div>

      <!-- 右侧表单 -->
      <div class="section-mian_right">
        <!-- NVR设备列表 -->
        <div v-if="nvrShow"
             class="nvr-table">
          <!-- 头部按钮 -->
          <div class="section-mian__toolbar">
            <el-button type="primary"
                       class="iss-operation-button"
                       icon="iconfont icon-iconfontfanhui"
                       @click="retBtn">{{ $t("deviceAccess.button.back") }}</el-button>
            <el-button type="primary"
                       class="iss-operation-button"
                       icon="iconfont icon-daoru"
                       @click="synData"
                       v-auth="'/deviceaccess/index:syncDevice'">同步所有</el-button>
            <el-button type="primary"
                       class="iss-operation-button"
                       icon="iconfont icon-daoru"
                       v-auth="'/deviceaccess/index:syncDevice'"
                       @click="synNVRData">单个同步</el-button>
            <el-button type="primary"
                       class="iss-operation-button"
                       icon="el-icon-plus"
                       v-auth="'/deviceaccess/index:addDevice'"
                       @click="addNvr"> 新增NVR</el-button>
            <!-- <el-button type="primary"
                       class="iss-operation-button"
                       icon="el-icon-delete"
                       @click="delDev"
                       v-auth="'/deviceaccess/index:deleteVideoManagement'">{{ $t("deviceAccess.button.batchDeletion") }}</el-button> -->
          </div>
          <!-- 搜索框部分 -->
          <div class="section-main__filter">
            <el-form ref="searchForm"
                     :inline="true"
                     :model="queryForm"
                     class="demo-form-inline">
              <el-form-item label="NVR名称：">
                <el-input clearable
                          v-model="queryForm.deviceName"
                          placeholder="请输入NVR名称" />
              </el-form-item>
              <el-form-item label="IP：">
                <el-input clearable
                          v-model="queryForm.deviceHost"
                          placeholder="请输入IP" />
              </el-form-item>
              <el-form-item label="厂商：">
                <el-input clearable
                          v-model="queryForm.factoryName"
                          placeholder="请输入厂商" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary"
                           @click="queryDev">{{
                $t("deviceAccess.button.query")
              }}</el-button>
                <el-button type="info"
                           @click="resetForm">{{
                $t("deviceAccess.button.reset")
              }}</el-button>
              </el-form-item>
            </el-form>
          </div>
          <!-- 表格部分 -->
          <div class="section-main_table">
            <ioc-table ref="devTab"
                       :data="deviceData"
                       :option="deviceOption"
                       :page="devicePage"
                       @row-save="handleCreate"
                       @current-change="selectPage"
                       @selection-change="selectionChange"
                       @size-change="changeSize">
              <!-- 定制操作栏按钮 -->
              <template slot="menu"
                        slot-scope="scope">
                <el-tooltip class="item"
                            effect="dark"
                            content="查看"
                            placement="top"
                            popper-class="tooltip-draw">
                  <el-button type="text"
                             @click="seeCamera(scope.row)"
                             icon="iconfont icon-Detail"></el-button>
                </el-tooltip>
                <el-tooltip class="item"
                            effect="dark"
                            :content="$t('deviceAccess.button.delete')"
                            placement="top"
                            popper-class="tooltip-draw">
                  <el-button type="text"
                             @click="delDevBtn(scope.row)"
                             icon="iconfont icon-shanchu"
                             v-auth="'/deviceaccess/index:deleteDevice'"></el-button>
                </el-tooltip>
                <el-tooltip class="item"
                            effect="dark"
                            content="详情"
                            placement="top"
                            popper-class="tooltip-draw">
                  <el-button type="text"
                             class="iconfont icon-Detail"
                             @click="showDetail(scope.row)"></el-button>
                </el-tooltip>
                <!-- <el-tooltip class="item"
                          effect="dark"
                          :content="$t('cameraList.label.update')"
                          placement="top"
                          popper-class="tooltip-draw">
                <el-button type="text"
                           class="el-icon-refresh"
                           @click="refresh(scope.row)"></el-button>
              </el-tooltip> -->
              </template>
            </ioc-table>
          </div>
        </div>
        <!-- NVR接入的摄像机列表 -->
        <div v-else
             class="nvr-table">
          <!-- 头部按钮 -->
          <div class="section-mian__toolbar">
            <el-button type="primary"
                       class="iss-operation-button"
                       icon="iconfont icon-iconfontfanhui"
                       @click="backNvr">{{ $t("deviceAccess.button.back") }}</el-button>
          </div>
          <!-- 搜索框部分 -->
          <div class="section-main__filter">
            <el-form ref="searchForm"
                     :inline="true"
                     :model="queryForm"
                     class="demo-form-inline">
              <el-form-item label="摄像机名称：">
                <el-input clearable
                          v-model="cameraQueryForm.deviceName"
                          placeholder="请输入摄像机名称" />
              </el-form-item>
              <el-form-item label="摄像机IP：">
                <el-input clearable
                          v-model="cameraQueryForm.deviceHost"
                          placeholder="请输入摄像机IP" />
              </el-form-item>
              <el-form-item label="状态：">
                <el-select v-model="cameraQueryForm.status"
                           clearable
                           placeholder="请选择状态">
                  <el-option v-for="item in statusOptions"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="IMES摄像机编号：">
                <el-input clearable
                          v-model="cameraQueryForm.thirdDeviceId"
                          placeholder="请输入IMES摄像机编号" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary"
                           @click="queryDev">
                  {{$t("deviceAccess.button.query")}}</el-button>
                <el-button type="info"
                           @click="resetForm">{{$t("deviceAccess.button.reset")}}</el-button>
              </el-form-item>
            </el-form>
            <div>
              <label for="">总数：</label>
              <span class="mr10">{{cameraCount.deviceAllCount}}</span>
              <label for="">在线：</label>
              <span class="mr10">{{cameraCount.deviceOnlineCount}}</span>
              <label for="">离线：</label>
              <span class="mr10">{{cameraCount.deviceOfflineCount}}</span>
              <!-- <label for="">其他：</label>
              <span></span> -->
            </div>
          </div>
          <!-- 表格部分 -->
          <div class="section-main_table">
            <ioc-table ref="devTab"
                       :data="cameraData"
                       :option="cameraOption"
                       :page="cameraPage"
                       @current-change="selectPage"
                       @selection-change="selectionChange"
                       @size-change="changeSize">
              <!-- 定制操作栏按钮 -->
              <template slot="menu"
                        slot-scope="scope">
                <!-- <el-tooltip class="item"
                            effect="dark"
                            content="查看"
                            placement="top"
                            popper-class="tooltip-draw">
                  <el-button type="text"
                             @click="seeStatus(scope.row)"
                             icon="iconfont icon-chakan"></el-button>
                </el-tooltip> -->
                <el-tooltip class="item"
                            effect="dark"
                            content="详情"
                            placement="top"
                            popper-class="tooltip-draw">
                  <el-button type="text"
                             class="iconfont icon-Detail"
                             @click="showDetail(scope.row)"></el-button>
                </el-tooltip>
              </template>
            </ioc-table>

          </div>
        </div>
      </div>

    </div>
    <!-- 查看详情 -->
    <el-dialog :title="$t('deviceAccess.title.devdetails')"
               :visible.sync="dialogVisible"
               v-dialogDrag
               width="500">
      <div class="devDtail"
           model="devDtail">
        <div class="devDtailLine">
          <div class="devDtailAtt">
            <span class="devDtailTit">{{
                      $t("deviceAccess.label.deivceip")
                    }}</span>
            <span class="devDtaildata"
                  :title="devDtail.deviceHost">{{
                      devDtail.deviceHost
                    }}</span>
          </div>
          <div class="devDtailAtt">
            <span class="devDtailTit">{{
                      $t("deviceAccess.label.subdevicetype")
                    }}</span>
            <span class="devDtaildata"
                  :title="devDtail.deviceSubType | deviceSubType">{{ devDtail.deviceSubType | deviceSubType }}</span>
          </div>
        </div>
        <div class="devDtailLine">
          <div class="devDtailAtt">
            <span class="devDtailTit">{{
                      $t("deviceAccess.label.deivcecode")
                    }}</span>
            <span class="devDtaildata"
                  :title="devDtail.thirdDeviceId">{{ devDtail.thirdDeviceId }}</span>
          </div>
          <div class="devDtailAtt">
            <span class="devDtailTit">{{
                      $t("deviceAccess.label.cameraname")
                    }}</span>
            <span class="devDtaildata"
                  :title="devDtail.deviceName">{{
                      devDtail.deviceName
                    }}</span>
          </div>
        </div>
        <div class="devDtailLine">
          <div class="devDtailAtt">
            <span class="devDtailTit">{{
                      $t("deviceAccess.label.parentcode")
                    }}</span>
            <span class="devDtaildata"
                  :title="devDtail.parentDeviceId">{{ devDtail.parentDeviceId }}</span>
          </div>
          <div class="devDtailAtt">
            <span class="devDtailTit">{{
                      $t("deviceAccess.label.domain")
                    }}</span>
            <span class="devDtaildata"
                  :title="devDtail.domainCode">{{
                      devDtail.domainCode
                    }}</span>
          </div>
        </div>
        <div class="devDtailLine">
          <div class="devDtailAtt">
            <span class="devDtailTit">{{
                      $t("deviceAccess.label.cameratype")
                    }}</span>
            <span class="devDtaildata"
                  :title="devDtail.deviceTypeName">{{ devDtail.deviceTypeName }}</span>
          </div>
          <div class="devDtailAtt">
            <span class="devDtailTit">{{
                      $t("deviceAccess.label.location")
                    }}</span>
            <span class="devDtaildata"
                  :title="devDtail.areaDevGroupName">{{ devDtail.areaDevGroupName }}</span>
          </div>
        </div>
        <div class="devDtailLine">
          <div class="devDtailAtt">
            <span class="devDtailTit">{{
                      $t("deviceAccess.label.network")
                    }}</span>
            <span class="devDtaildata"
                  :title="devDtail.netType">{{
                      devDtail.netType
                    }}</span>
          </div>
          <div class="devDtailAtt">
            <span class="devDtailTit">{{
                      $t("deviceAccess.label.status")
                    }}</span>
            <span class="devDtaildata"
                  :title="devDtail.status">{{
                      devDtail.status
                    }}</span>
          </div>
        </div>
        <div class="devDtailLine">
          <div class="devDtailAtt">
            <span class="devDtailTit">{{
                      $t("deviceAccess.label.volice")
                    }}</span>
            <span class="devDtaildata"
                  :title="devDtail.enableVoice">{{
                      devDtail.enableVoice
                    }}</span>
          </div>
          <div class="devDtailAtt">
            <span class="devDtailTit">{{
                      $t("deviceAccess.label.supportanalyse")
                    }}</span>
            <span class="devDtaildata"
                  :title="devDtail.isSupportIntelligent">{{ devDtail.isSupportIntelligent }}</span>
          </div>
        </div>
        <div class="devDtailLine">
          <div class="devDtailAtt">
            <span class="devDtailTit">{{
                      $t("deviceAccess.label.creattime")
                    }}</span>
            <span class="devDtaildata"
                  :title="devDtail.createTime | moment">{{ devDtail.createTime | moment }}</span>
          </div>
          <div class="devDtailAtt">
            <span class="devDtailTit">{{
                      $t("deviceAccess.label.nvr")
                    }}</span>
            <span class="devDtaildata"
                  :title="devDtail.nvrCode">{{
                      devDtail.nvrCode
                    }}</span>
          </div>
        </div>
        <div class="devDtailLine">
          <div class="devDtailAtt">
            <span class="devDtailTit">{{
                      $t("deviceAccess.label.exdomain")
                    }}</span>
            <span class="devDtaildata"
                  :title="devDtail.isExDomain">{{
                      devDtail.isExDomain
                    }}</span>
          </div>
          <div class="devDtailAtt">
            <span class="devDtailTit"></span>
            <span class="devDtaildata"></span>
          </div>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="dialogVisible = false">{{
                $t("deviceAccess.button.close")
              }}</el-button>
      </span>
    </el-dialog>
    <!-- 修改弹窗 -->
    <el-dialog title="修改区域"
               v-ops:width="500"
               v-dialogDrag
               :visible.sync="formShow"
               @close="formClose"
               :close-on-click-modal="false">
      <el-form ref="form">
        <el-form-item label="区域名称："
                      label-width="100px"
                      prop="name">
          <el-input v-model="areaName"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述："
                      label-width="100px"
                      prop="name">
          <el-input v-model="description"
                    type="textarea"
                    autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="saveArea"
                   v-status>
          保存
        </el-button>
        <el-button @click="formClose"> 取消 </el-button>
      </span>
    </el-dialog>
    <!-- 摄像机当前视频流的状态 -->
    <!-- <el-dialog title="视频流状态"
               v-ops:width="500"
               :visible.sync="statusFormShow"
               :close-on-click-modal="false">
      <el-tabs v-model="activeName"
               @tab-click="handleClick">
        <el-tab-pane label="视频直播流状态"
                     name="first">

          <ioc-table ref="devTab"
                     :data="videoStreamData"
                     :option="videoStreamOption"
                     :page="cameraPage"
                     @current-change="selectPage"
                     @selection-change="selectionChange"
                     @size-change="changeSize"></ioc-table>
        </el-tab-pane>
        <el-tab-pane label="视频流片段列表"
                     name="second">视频流片段列表</el-tab-pane>
      </el-tabs>

      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="saveArea"
                   v-status>
          保存
        </el-button>
        <el-button @click="formClose"> 取消 </el-button>
      </span>
    </el-dialog> -->
  </div>
</template>
<script>
import { api } from "../../api/index";
import { Dic } from "$utils";
import utils from '@src/common/utils'
import i18n from "@src/common/lib/i18n";
import { tableOption } from '../../config/NvrTable'
import { cameraOption } from '../../config/cameraTable'

export default {
  filters: {
    // 子设备类型过滤
    deviceSubType: function (val) {
      switch (val) {
        case "2":
          return i18n.t("deviceAccess.label.cameradev");
        case "3":
          return i18n.t("deviceAccess.label.langdev");
        case "4":
          return i18n.t("deviceAccess.label.alarmdev");
      }
    },
  },
  data () {
    return {
      activeName: 'first',
      tipData: "",
      // 单个删除设备的数据
      delDevSin: {},
      delConfirm: false,
      // 设备详情数据
      devDtail: {
        deviceHost: "",
        thirdDeviceId: "",
        parentCode: "",
        type: "",
        netType: "",
        enableVoice: "",
        deviceCreateTime: "",
        deviceSubType: "",
        isExDomain: "",
        deviceName: "",
        domainCode: "",
        cameraLocation: "",
        status: "",
        isSupportIntelligent: "",
        nvrCode: "",
      },
      // 详情弹框
      dialogVisible: false,
      // 存储列表数据获取方式：1、通过左侧树；2、通过搜索条件；删除时用同样的方式刷新列表数据
      getDevListType: "",
      // 选中设备ID集合
      selDev: [],
      // 选择的第三方设备ID
      thirdDeviceIdList: [],
      // 查询字段
      queryForm: {
        factoryName: "",
        deviceName: "",
        deviceHost: "",
        deviceMark: "19"
      },
      cameraQueryForm: {
        deviceName: "",
        deviceHost: "",
        thirdDeviceId: "",
        status: "",
      },
      // 系统id
      systemId: "",
      platID: "",
      factoryId: "",
      systemName: "",
      deviceType: "",
      // 树的props
      treeProps: {
        label: "areaName",
        children: "subDeviceList",
      },
      // treeProps: {
      //   label: "thirdDeviceName",
      //   children: "subDeviceList",
      // },
      // 设备树的数据
      frame: [],
      // 树的节点值
      treeKey: "-1",
      // 设备ID
      deviceId: "",
      // 分页属性设置
      devicePage: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },
      cameraPage: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },
      deviceData: [

      ],
      cameraData: [

      ],
      videoStreamData: [],
      deviceOption: tableOption(this),
      cameraOption: cameraOption(this),
      level: "",
      nvrShow: true,
      cameraCount: {
        deviceAllCount: null,
        deviceOnlineCount: null,
        deviceOfflineCount: null,
      },
      statusOptions: [
        {
          label: '在线',
          value: '1'
        },
        {
          label: '离线',
          value: '0'
        }
      ],
      areaName: '',
      description: '',
      areaCode: '',
      formShow: false,
      statusFormShow: false,
    };
  },
  created () {
    this.systemId = this.$route.query.systemId;
    this.systemName = this.$route.query.systemName;
    this.platID = this.$route.query.platID;
    this.factoryId = this.$route.query.factoryId;
    this.deviceType = this.$route.query.deviceType;
  },
  mounted () {
    // 请求树根节点
    this.getAccessDeviceInfoTree();
    // 请求设备列表
    this.getDevList();
    // 请求边缘节点ID
    this.queryEdgeNodeList()
    this.queryFactoryList()
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event);
    },
    // 返回按钮
    retBtn () {
      this.$router.go(-1);
    },
    // 同步数据
    synData () {
      const params = {
        systemId: 200000005,
        platId: 32,
        factoryId: "10",
        deviceType: 10,
      };
      this.$fetch(api.device.syncDevice, params).then((res) => {
        if (res.success) {
          this.$message.success('同步成功');
          this.resetForm();
          // 请求树根节点
          this.getAccessDeviceInfoTree();
          // 请求设备列表
          // this.getDevList();
          // 重置搜索条件
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 同步NVR设备
    synNVRData () {
      if (this.thirdDeviceIdList.length === 0) {
        this.$message.warning('请选择需要同步的NVR设备');
        return;
      }
      const params = {
        systemId: 200000005,
        platId: 32,
        factoryId: "10",
        deviceType: 10,
        thirdDeviceIdList: this.thirdDeviceIdList
      };
      this.$fetch(api.device.syncNvrDevice, params).then((res) => {
        if (res.success) {
          this.$message.success('同步NVR设备成功');
          this.resetForm();
          // 请求树根节点
          this.getAccessDeviceInfoTree();
          // 请求设备列表
          // this.getDevList();
          // 重置搜索条件
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    addNvr () {
      if (!this.areaCode) {
        this.$message.error('请选择区域')
        return
      }
      this.$refs.devTab.rowAdd()
    },
    // 树的子节点点击事件
    currentChange (data, node) {
      this.$log.info("树的子节点点击", data);
      this.isTopTreeNode = data.areaCode !== '-1' ? false : true
      // let parentNode = this.$refs.vuetree.getNode(data.parentCode)
      this.areaCode = data.areaCode
      this.treeKey = data.deviceID;
      this.level = node.level;
      if (this.level) {
        this.deviceId = data.deviceID;
      }
      this.getDevList();
    },
    // 20210206 区域新接口
    getAccessDeviceInfoTree () {
      const params = {
        // systemId: this.systemId,
      };
      this.$fetch(api.device.queryAreaList, params).then((res) => {
        if (res.success) {
          this.frame = res.returnObj;
          this.$nextTick(() => {
            this.$refs.vuetree.setCurrentKey("-1");
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // getAccessDeviceInfoTree () {
    //   const params = {
    //     systemId: this.systemId,
    //   };
    //   this.$fetch(api.device.queryPlatSystemDeviceTree, params).then((res) => {
    //     if (res.success) {
    //       this.frame = [res.returnObj];
    //       this.$nextTick(() => {
    //         this.$refs.vuetree.setCurrentKey("-1");
    //       });
    //     } else {
    //       this.$message.error(res.msgContent);
    //     }
    //   });
    // },
    // 请求数据列表数据
    requestList () {
      const param = {
        pageSize: this.devicePage.pageSize,
        pageNum: this.devicePage.currentPage,
        systemId: this.systemId,
        factoryName: this.factoryName,
        deviceHost: this.queryForm.deviceHost,
        deviceName: this.queryForm.deviceName,
        deviceMark: this.queryForm.deviceMark,
        // parentDeviceId: this.treeKey,
      };
      // if (param.parentDeviceId == "-1") {
      //   param.parentDeviceId = "";
      // }
      this.$fetch(api.device.queryPlatSystemDeviceList, param).then((res) => {
        if (res.success && res.returnObj.list) {
          this.deviceData = res.returnObj.list;
          // this.devicePage.pageSize = res.returnObj.pageSize;
          this.devicePage.total = res.returnObj.total;
        } else {
          this.$message.error(res.msgContent);

        }
      });
    },
    // 请求数据列表数据
    requestCameraList () {
      const params = {
        pageSize: this.cameraPage.pageSize,
        pageNum: this.cameraPage.currentPage,
        systemId: 200000005,
        status: this.cameraQueryForm.status,
        deviceName: this.cameraQueryForm.deviceName,
        deviceHost: this.cameraQueryForm.deviceHost,
        thirdDeviceId: this.cameraQueryForm.thirdDeviceId,
        parentDeviceId: this.parentDeviceId,
      };
      this.$fetch(api.device.queryPlatSystemDeviceList, params).then((res) => {
        if (res.success && res.returnObj.list) {
          this.cameraData = res.returnObj.list;
          // this.cameraPage.pageSize = res.returnObj.pageSize;
          this.cameraPage.total = res.returnObj.total;
        }
      });
    },
    // 根据查询条件查询列表
    queryDev () {
      if (this.nvrShow) {
        this.devicePage.currentPage = 1;
        this.getDevListType = 1;
        this.requestList();
      } else {
        this.requestCameraList()
      }
    },
    // 根据树查询设备列表
    getDevList () {
      this.devicePage.currentPage = 1;
      this.getDevListType = 2;
      this.requestList();
    },

    // 批量删除设备
    delDev () {
      if (this.selDev.length === 0) {
        this.$message.warning(this.$t("deviceAccess.message.deltips"));
        return;
      }
      this.delConfirm = true;
      this.$confirm(
        this.$t("deviceAccess.message.uninstall"),
        this.$t("deviceAccess.title.uninstall"),
        {
          confirmButtonText: this.$t("deviceAccess.button.confirm"),
          cancelButtonText: this.$t("deviceAccess.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.dlgYes();
      });
    },
    // 单独删除设备
    delDevBtn (row) {
      this.selDev = [row.deviceID];
      this.$confirm(
        this.$t("deviceAccess.message.uninstall"),
        this.$t("deviceAccess.title.uninstall"),
        {
          confirmButtonText: this.$t("deviceAccess.button.confirm"),
          cancelButtonText: this.$t("deviceAccess.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.dlgYes(row);
      });
    },
    // 确认删除
    dlgYes (row) {
      this.devicePage.currentPage = 1;
      this.delConfirm = false;
      // let params = { deviceIDList: this.selDev };
      this.$fetch(api.device.deletePlatDevice, { deviceID: row.deviceID }).then((res) => {
        if (res.success) {
          if (this.getDevListType == 1) {
            this.queryDev();
          } else if (this.getDevListType == 2) {
            this.getDevList();
          }
          this.$message.success(this.$t("deviceAccess.message.delsuccess"));
        } else {
          this.$message.error(res.msgContent);
        }
        this.$refs.devTab.selectClear();
      });
    },

    // 取消删除
    dlgNo () {
      this.delConfirm = false;
    },

    refresh (row) {
      const params = {
        deviceID: row.deviceID,
      };
      this.$fetch(api.device.queryPlatSystemDeviceDetail, params).then(
        (res) => {
          if (res.success) {
            row.status = res.returnObj.status;
            this.$message.success(res.msgContent);
          } else {
            this.$message.error(res.msgContent);
          }
        }
      );
    },

    //迭代四  新接口 查看详情
    showDetail (row) {
      this.$refs.devTab.rowView(row)
      // this.dialogVisible = true;
      // const params = {
      //   deviceID: row.deviceID,
      // };
      // this.$fetch(api.device.queryPlatSystemDeviceDetail, params).then(
      //   (res) => {
      //     if (res.success) {
      //       this.devDtail = res.returnObj;
      //       this.devDtail.status = Dic.findByValue(
      //         "SENU015",
      //         res.returnObj.status
      //       );
      //     } else {
      //       this.$message.error(res.msgContent);
      //     }
      //   }
      // );
    },
    //查看NVR接入的摄像机列表，同时显示接入数量的总数
    seeCamera (row) {
      this.parentDeviceId = row.deviceID
      this.nvrShow = false
      this.queryCameraCount(row.deviceID)
      this.requestCameraList()
    },
    seeStatus (row) {
      console.log('row', row)
      const params = {
        "pageNum": 1,
        "pageSize": 10,
        "thirdDeviceId": row.thirdDeviceId
      }
      this.$fetch(api.device.queryVideoStream, params).then((res) => {
        if (res.success) {
          this.videoStreamData = res.returnObj.list;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    backNvr () {
      this.nvrShow = true
      this.cameraQueryForm = {
        deviceName: "",
        deviceHost: "",
        thirdDeviceId: "",
        status: "",
      }
    },
    // 重置搜索
    resetForm () {
      if (this.nvrShow) {
        this.devicePage.pageSize = utils.Cache.get('CURRENT_PAGESIZE') || 10;
        this.devicePage.pageNo = 1;
        this.queryForm = {
          factoryName: "",
          deviceName: "",
          deviceHost: "",
          deviceMark: "19"
        };
        this.getAccessDeviceInfoTree();
        // 请求设备列表

        this.getDevListType = 2;
        this.treeKey = "";
        this.requestList();
        this.devicePage.currentPage = 1;
      } else {
        this.cameraQueryForm = {
          deviceName: "",
          deviceHost: "",
          thirdDeviceId: "",
          status: "",
        }
        this.requestCameraList()
      }
    },

    // 当选择项发生变化时会触发该事件
    selectionChange (selections) {
      let myAry = [];
      let thirdList = [];
      selections.map((item) => {
        myAry.push(item.deviceID);
        thirdList.push(item.thirdDeviceId)
      });
      this.thirdDeviceIdList = thirdList;
      this.selDev = myAry;
    },
    // 点击上一页下一页按钮
    selectPage (val) {
      if (this.nvrShow) {
        this.devicePage.currentPage = val;
        if (this.getDevListType == 1) {
          this.getDevListType = 1;
          this.requestList();
        } else if (this.getDevListType == 2) {
          this.getDevListType = 2;
          this.requestList();
        }
      } else {
        this.cameraPage.currentPage = val;
        this.requestCameraList();
      }
    },
    // 修改每页数据数量
    changeSize (val) {
      if (this.nvrShow) {
        this.devicePage.currentPage = 1;
        this.devicePage.pageSize = val;
        if (this.getDevListType == 1) {
          this.queryDev();
        } else if (this.getDevListType == 2) {
          this.getDevList();
        }
      } else {
        this.cameraPage.currentPage = 1;
        this.cameraPage.pageSize = val;
        this.requestCameraList()
      }
    },
    queryCameraCount (parentDeviceId) {
      this.$fetch(api.device.queryCameraCount, { parentDeviceId: parentDeviceId }).then((res) => {
        if (res.success) {
          this.cameraCount = res.returnObj
        } else {
          this.$message.error(res.msgContent);
        }
      }
      );
    },
    addClick (event) {
      // console.log('eeeeeeeeeeeeeeeeeeee', event)
      event.stopPropagation()
    },
    editArea (node, data) {
      this.areaName = data.areaName
      this.areaCode = data.areaCode
      this.description = data.description
      this.formShow = true;
    },
    formClose () {
      this.formShow = false;
      this.areaName = ''
      // this.$refs["form"].clearValidate();
    },
    saveArea () {
      const params = {
        "areaCode": this.areaCode,
        "areaName": this.areaName,
        "description": this.description,
        "connectMode": "EDGE",
        "pushDomain": "push.sdnewtimes.com",
        "pullDomain": "play.sdnewtimes.com"
      }
      this.$fetch(api.device.updateArea, params).then(
        (res) => {
          if (res.success) {
            this.formShow = false
            this.getAccessDeviceInfoTree()
            this.$message.success('修改成功')
          } else {
            this.$message.error(res.msgContent);
          }
        }
      );
    },
    queryEdgeNodeList () {
      this.$fetch(api.device.queryEdgeNodeList).then((res) => {
        if (res.success) {
          this.deviceOption.column[5].dicData = res.returnObj.map(item => {
            return {
              label: item.edgeNodeName,
              value: item.edgeNodeCode,
            }
          })
          console.log('this.deviceOption', this.deviceOption)
        }
      });
    },
    queryFactoryList () {
      this.$fetch(api.device.queryFactoryList).then((res) => {
        if (res.success) {
          this.deviceOption.column[1].dicData = res.returnObj.map(item => {
            return {
              label: item.factoryName,
              value: item.factoryId,
            }
          })
          console.log('this.deviceOption', this.deviceOption)
        }
      });
    },
    // 新增nvr
    handleCreate (addInfo, done) {
      this.$refs['devTab'].$refs['form'].validate((valid) => {
        if (!valid) {
          return false
        } else {
          let form = {
            areaCode: this.areaCode,
            parentDeviceId: "200000005",
            parentDeviceIds: "200000005",
            accessProtocol: Dic.findByValue(
              "SENU093",
              addInfo.accessProtocol
            ),
            thirdDeviceName: addInfo.deviceName,
            factoryId: addInfo.factoryName,
            systemId: 200000005,
          }
          const params = Object.assign(addInfo, form)
          this.$fetch(api.device.addPlatSystemDevice, params).then((res) => {
            if (res && res.success) {
              this.requestList()
              this.$message.success('新增成功')
            } else {
              this.$message.error(res.msgContent)
            }
            done()
          })
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.vcnDeviceList {
  width: 100%;
  height: 100%;
  .section-main__warp {
    margin: 0 !important;
  }
}
</style>
<style lang="scss">
.vcnDevicelist_warpd {
  .el-table__fixed-right-patch {
    display: none;
  }
  .devDtaildata {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .nvr-table {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .tree-content {
    width: fit-content;
    min-width: 100%;
    .el-tree-node__label {
      display: inline-block;
      max-width: 80%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .el-tree-node__content {
      height: 40px;
      line-height: 40px;
      &:hover {
        background: rgb(45, 73, 118);
      }
      .custom-tree-node {
        width: 100%;
        height: 40px;
        line-height: 40px;
        display: flex;
        .tree-label {
          width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .area-operator {
          display: inline-block;
          margin-left: 10px;
        }
      }
      &:before {
        margin-top: -26px !important;
      }
    }
  }
}
.el-select {
  width: 100%;
}
</style>
